import { render } from "./QuestionContainer.vue?vue&type=template&id=dbf42276"
import script from "./QuestionContainer.vue?vue&type=script&lang=js"
export * from "./QuestionContainer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__